import React from "react";
import { Patient } from "../../services/patientsService";
import { Select, SelectOption } from "../Select";

interface PatientsFilterProps {
  patients: Patient[];
  selectedPatients: number[];
  onPatientsChange: (patientIds: number[]) => void;
  onOpen?: () => void;
  onClose?: () => void;
  loading?: boolean;
  width: number;
}

const PatientsFilter: React.FC<PatientsFilterProps> = ({
  patients,
  selectedPatients,
  onPatientsChange,
  onOpen,
  onClose,
  loading = false,
  width = 350,
}) => {
  const handleChange = (value: string | number | (string | number)[]) => {
    const newPatients = Array.isArray(value)
      ? value.map(Number)
      : [Number(value)];

    const wasAllPatientsSelected = selectedPatients.length === 0;

    // If "All Patients" is selected
    if (newPatients.length === 1 && newPatients[0] === 0) {
      onPatientsChange([]);
      return;
    }

    // If transitioning from "All Patients" to specific patients
    if (wasAllPatientsSelected && newPatients.includes(0)) {
      const filteredPatients = newPatients.filter((id) => id !== 0);
      onPatientsChange(filteredPatients);
      return;
    }

    // If "All Patients" is selected along with specific patients
    if (newPatients.includes(0) && newPatients.length > 1) {
      onPatientsChange([]);
      return;
    }

    onPatientsChange(newPatients);
  };

  const options: SelectOption[] = [
    { value: 0, label: "All Patients" },
    ...patients.map((patient) => ({
      value: patient.id,
      label: `${patient.firstName} ${patient.lastName}`,
    })),
  ];

  return (
    <Select
      label="Patients"
      multiple
      width={width}
      options={options}
      value={selectedPatients.length === 0 ? [0] : selectedPatients}
      onChange={handleChange}
      onOpen={onOpen}
      onClose={onClose}
      loading={loading}
    />
  );
};

export default PatientsFilter;
